// utils/DynamicIcon.tsx
import * as GIIcons from 'react-icons/gi';

interface DynamicIconProps {
  name: string; // e.g. 'Gi3DGlasses'
  size?: number;
  color?: string;
}

const DynamicIcon = ({ name }: DynamicIconProps) => {
  const IconComponent = (GIIcons as Record<string, React.ElementType>)[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in react-icons/gi`);
    return null;
  }

  return <IconComponent />;
};

export default DynamicIcon;
